import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react';

import { useField } from '@unform/core';

import * as S from './styles';

interface IInputFileProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  placeholder?: string;
  classNameContainer?: string;
  required?: boolean;
  icon: string;
  position: 'left' | 'right';
}

const InputFile: React.FC<IInputFileProps> = ({
  name,
  label,
  placeholder = '',
  classNameContainer = '',
  required = false,
  icon,
  position,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, error } = useField(name);

  const [fileName, setFileName] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue(ref: HTMLInputElement) {
        return ref.files && ref.files;
      },
      clearValue(ref: HTMLInputElement) {
        ref.value = '';
      },
    });
  }, [fieldName, registerField]);

  const handleFileChange = event => {
    const file = event.target.files[0];

    if (file) {
      setFileName(file.name);
    } else {
      setFileName('Nenhum arquivo selecionado');
    }
  };

  const handleClearFile = () => {
    setFileName('');

    const input = document.getElementById('fileInput') as HTMLInputElement;
    input.value = null;
  };

  return (
    <S.Container
      className={`input-file${
        classNameContainer ? ` ${classNameContainer}` : ''
      }`}
    >
      <label
        htmlFor={name}
        className={`label ${required ? 'required' : ''}
            }`}
      >
        {label}
      </label>

      <label htmlFor={name} className={`label-input ${position}`}>
        {!fileName && position === 'left' && (
          <img
            src={`/images/icons/${icon}`}
            alt="Anexar"
            className={`icon file-icon ${position}`}
          />
        )}

        {fileName ? (
          <p className="name">{fileName}</p>
        ) : placeholder ? (
          <p className="placeholder">{placeholder}</p>
        ) : (
          <p className="name">Escolher arquivo</p>
        )}

        {!fileName && position === 'right' && (
          <img
            src={`/images/icons/${icon}`}
            alt="Anexar"
            className={`icon file-icon ${position}`}
          />
        )}
      </label>

      <input
        {...rest}
        id={name}
        ref={inputRef}
        type="file"
        onChange={handleFileChange}
      />

      {!!fileName && (
        <img
          src="/images/icons/x-black.svg"
          alt="Fechar"
          className="icon delete-file-icon"
          onClick={handleClearFile}
        />
      )}
    </S.Container>
  );
};

export default InputFile;
